import { gql } from 'apollo-boost'

const GET_USER = gql`
  {
    user @client {
      id
      email
      name
    }
  }
`

export default GET_USER
